const countryData = [
  {
    label: 'Argentina(+54)',
    value: 'AR',
    displayValue: 'AR(+54)',
  },
  {
    label: 'Austria(+43)',
    value: 'AT',
    displayValue: 'AT(+43)',
  },
  {
    label: 'Australia(+61)',
    value: 'AU',
    displayValue: 'AU(+61)',
  },
  {
    label: 'Belgium(+32)',
    value: 'BE',
    displayValue: 'BE(+32)',
  },
  {
    label: 'Brunei(+673)',
    value: 'BN',
    displayValue: 'BN(+673)',
  },
  {
    label: 'Canada (+1)',
    value: 'CA',
    displayValue: 'CA(+1)',
  },
  {
    label: 'Switzerland(+41)',
    value: 'CH',
    displayValue: 'CH(+41)',
  },
  {
    label: 'Chile(+56)',
    value: 'CL',
    displayValue: 'CL(+56)',
  },
  {
    label: 'Colombia(+57)',
    value: 'CO',
    displayValue: 'CO(+57)',
  },
  {
    label: 'Czech Republic(+420)',
    value: 'CZ',
    displayValue: 'CZ(+420)',
  },
  {
    label: 'Germany(+49)',
    value: 'DE',
    displayValue: 'DE(+49)',
  },
  {
    label: 'Denmark(+45)',
    value: 'DK',
    displayValue: 'DK(+45)',
  },
  {
    label: 'Spain(+34)',
    value: 'ES',
    displayValue: 'ES(+34)',
  },
  {
    label: 'Finland(+358)',
    value: 'FI',
    displayValue: 'FI(+358)',
  },
  {
    label: 'France(+33)',
    value: 'FR',
    displayValue: 'FR(+33)',
  },
  {
    label: 'United Kingdom(+44)',
    value: 'GB',
    displayValue: 'GB(+44)',
  },
  {
    label: 'Hong Kong(+852)',
    value: 'HK',
    displayValue: 'HK(+852)',
  },
  {
    label: 'Hungary(+36)',
    value: 'HU',
    displayValue: 'HU(+36)',
  },
  {
    label: 'Indonesia(+62)',
    value: 'ID',
    displayValue: 'ID(+62)',
  },
  {
    label: 'Ireland(+353)',
    value: 'IE',
    displayValue: 'IE(+353)',
  },
  {
    label: 'Israel(+972)',
    value: 'IL',
    displayValue: 'IL(+972)',
  },
  {
    label: 'Iceland(+354)',
    value: 'IS',
    displayValue: 'IS(+354)',
  },
  {
    label: 'Italy(+39)',
    value: 'IT',
    displayValue: 'IT(+39)',
  },
  {
    label: 'Japan(+81)',
    value: 'JP',
    displayValue: 'JP(+81)',
  },
  {
    label: 'South Korea(+82)',
    value: 'KR',
    displayValue: 'KR(+82)',
  },
  {
    label: 'Luxembourg(+352)',
    value: 'LU',
    displayValue: 'LU(+352)',
  },
  {
    label: 'Macau(+853)',
    value: 'MO',
    displayValue: 'MO(+853)',
  },
  {
    label: 'Mexico(+52)',
    value: 'MX',
    displayValue: 'MX(+52)',
  },
  {
    label: 'Malaysia(+60)',
    value: 'MY',
    displayValue: 'MY(+60)',
  },
  {
    label: 'New Caledonia(+687)',
    value: 'NC',
    displayValue: 'NC(+687)',
  },
  {
    label: 'The Netherlands(+31)',
    value: 'NL',
    displayValue: 'NL(+31)',
  },
  {
    label: 'Norway(+47)',
    value: 'NO',
    displayValue: 'NO(+47)',
  },
  {
    label: 'New Zealand(+64)',
    value: 'NZ',
    displayValue: 'NZ(+64)',
  },
  {
    label: 'Peru(+51)',
    value: 'PE',
    displayValue: 'PE(+51)',
  },
  {
    label: 'French Polynesia(+689)',
    value: 'PF',
    displayValue: 'PF(+689)',
  },
  {
    label: 'Philippines(+63)',
    value: 'PH',
    displayValue: 'PH(+63)',
  },
  {
    label: 'Poland(+48)',
    value: 'PL',
    displayValue: 'PL(+48)',
  },
  {
    label: 'Portugal(+351)',
    value: 'PT',
    displayValue: 'PT(+351)',
  },
  {
    label: 'Romania(+40)',
    value: 'RO',
    displayValue: 'RO(+40)',
  },
  {
    label: 'Russia(+7)',
    value: 'RU',
    displayValue: 'RU(+7)',
  },
  {
    label: 'Sweden(+46)',
    value: 'SE',
    displayValue: 'SE(+46)',
  },
  {
    label: 'Singapore(+65)',
    value: 'SG',
    displayValue: 'SG(+65)',
  },
  {
    label: 'Slovakia(+421)',
    value: 'SK',
    displayValue: 'SK(+421)',
  },
  {
    label: 'Thailand(+66)',
    value: 'TH',
    displayValue: 'TH(+66)',
  },
  {
    label: 'Taiwan(+886)',
    value: 'TW',
    displayValue: 'TW(+886)',
  },
  {
    label: 'Turkey(+90)',
    value: 'TR',
    displayValue: 'TR(+90)',
  },
  {
    label: 'Ukraine(+380)',
    value: 'UA',
    displayValue: 'UA(+380)',
  },
  {
    label: 'United States(+1)',
    value: 'US',
    displayValue: 'US(+1)',
  },
  {
    label: 'Vietnam(+84)',
    value: 'VN',
    displayValue: 'VN(+84)',
  },
  {
    label: 'South Africa(+27)',
    value: 'ZA',
    displayValue: 'ZA(+27)',
  },
]

export { countryData }
